import * as React from 'react';
import Box from '@mui/material/Box';
import HomeTop from "../components/HomeTop";
import Bottom from "./Bottom";
import HistoryHome from './History/HistoryHome';
import Container from '@mui/material/Container';
import HistoryBurnKcal from './History/HistoryBurnKcal';
import HistoryDrinkWater from './History/HistoryDrinkWater';
import HistoryEatFood from './History/HistoryEatFood';
import HistoryWalking from './History/HistoryWalking';
import { BrowserRouter as Router, Routes,Route, Link } from 'react-router-dom';

const History = () => {
    
  return (
    <Container sx={{p: '0 !important', bgcolor: '#F6F6F6', minWidth: 320,minHeight: '100vh'  }}>
      {/* <HomeTop/> */}
      
      <HistoryHome/>
      <Bottom/>
    </Container>
  );
}
export default History;